import { yieldVaultContractConfig } from "@config/contractsConfig";
import useDappChain from "./useDappChain";
import { useAccount, useReadContracts } from "wagmi";
import { formatEther } from "viem";
import { useMemo } from "react";

const useDepositLimit = (asset: any, conversion: any) => {
  const { chain } = useDappChain();
  const { address: walletAddress } = useAccount();

  const depositLimitContracts = useMemo(() => {
    const vaultConfig =
      yieldVaultContractConfig[chain.id]?.interactionPool || {};
    const contracts = [];
    contracts.push({
      ...vaultConfig,
      functionName: "maxDeposit",
      args: [asset],
    });

    contracts.push({
      ...vaultConfig,
      functionName: "totalAssets",
    });

    return contracts;
  }, [asset, chain.id]);

  const { data } = useReadContracts({
    contracts: [...depositLimitContracts],
    query: {
      enabled: !!walletAddress,
      refetchInterval: 10_000,
    },
  });

  const depositLimit = useMemo(() => {
    if (!data || !data[0]?.result || !data[1]?.result) return 0;

    const maxDeposit = (data[0].result as bigint) || 0n;
    const totalAssets = (data[1].result as bigint) || 0n;

    const formattedMaxDeposit = Number(formatEther(maxDeposit));
    const formattedTotalAssets = Number(formatEther(totalAssets));

    return conversion.fromERC20 > 0
      ? formattedMaxDeposit - formattedTotalAssets * conversion.fromERC20
      : formattedMaxDeposit - formattedTotalAssets;
  }, [data, conversion.fromERC20]);

  return {
    depositLimit: depositLimit,
    maxDeposit:
      data && data[0]?.result
        ? Number(formatEther(data[0].result as bigint))
        : 0,
  };
};

export default useDepositLimit;
